import React, { useContext } from 'react'
import { ContentInner } from '../../layout/Content'
import { OR8p5inchStyle, OR58mmStyle, EMSI8p5inchStyle, EMSI58mmStyle } from './css/ReceiptItemInnerStyle'
import PrinterSettingsStyle from '../../../css/PrinterSettingsStyle'
import { receiptItemControllerContext } from './ReceiptItemController'
import { formatNumber } from '../../utilities/utilities'

function OfficialReceipt() {
  const receiptItemController = useContext(receiptItemControllerContext)
  const { receipt, client } = receiptItemController
  const paperSize = receiptItemController.paperSize[0]
  const paymentFor = (receipt.receipt_for.item_name === 'Invoice') ? 'Sales Invoice' : 'Customer Credit Account'
  const totalAmountPaid = parseFloat(receipt.payments.find(item => item.name === 'total_amount_paid').total_amount_paid)
  const totalAmountDue = (parseFloat(receipt.amount_to_pay.total_amount) - parseFloat(receipt.discounts.discount_total.total_discount_amount))
  const totalAmountToPay = parseFloat(receipt.amount_to_pay.total_amount)
  const totalBalanceChange = parseFloat(totalAmountDue - totalAmountPaid)

  function OR8p5inch() {
    return (
      <React.Fragment>
        <div className='report-wrapper'>
          <div id='or-item-container' className={(paperSize === '8.5inch') ? 'OR8p5inch printable' : 'OR8p5inch'}>
            <div className='invoice-company-name-address-container'>
              <div><b>{client.company_profile.company_name}</b></div>
              <div>
                {`
                  ${client.company_address.street},
                  ${client.company_address.zip_code} ${client.company_address.city},
                  ${client.company_address.state} ${client.company_address.country}
                `}
              </div>
              <div>T.I.N: {client.company_profile.tin}</div>
              <div>Contact Number: {client.company_profile.contact_number}</div>
            </div>
            <br/>
            <div className='receipt-header'>
              <div className='or-label'><b>Official Receipt</b></div>
              <div className='or-date'>{new Date(receipt.receipt_date).toLocaleString("en-us", { timeZone: receipt.client_timezone }).split(',')[0]} { receipt.client_timezone }</div>
              <div className='or-number'><b>Receipt Number:</b> {receipt._id.toUpperCase()}</div>
            </div>

            <div className='receipt-inner'>
              <div className='receipt-inner-message'>
                {
                  (receipt.receipt_for.item_name === 'Invoice')
                  ? `Payment for the ${paymentFor} ${receipt.receipt_for.item_id.toString().toUpperCase()} amounting to P${formatNumber(totalAmountToPay)}.`
                  : `Payment for customer ${receipt.receipt_for.item_id.customer_account_id.toUpperCase()} with ${paymentFor} number ${receipt.receipt_for.item_id.credit_account_number.toString().toUpperCase()} amounting to P${formatNumber(totalAmountToPay)}.`
                }
              </div>
              <div className='receipt-summary'>
                <div className='receipt-summary-item'>
                  <div className='receipt-summary-label'>Amount to Pay</div>
                  <div className='receipt-summary-data'>{`P${formatNumber(totalAmountToPay)}`}</div>
                </div>
                <hr />

                <div className='receipt-summary-item'>
                  <div className='receipt-summary-label'>Discount ({receipt.discounts.discount_total.total_percent_discount}%)</div>
                  <div className='receipt-summary-data'>P{formatNumber(receipt.discounts.discount_total.total_discount_amount)}</div>
                </div>
                {
                  (receipt.discounts.items.map((discount, index) => (
                    <div key={index}>
                      <div className='receipt-summary-item sub-content'>
                        {
                          (discount.vat_exempted)
                          ? <div className='receipt-summary-label'>
                            {discount.discount_authority_name} (VAT Exempted) ({discount.percent_discount}%)
                            </div>
                          : <div className='receipt-summary-label'>
                            {discount.discount_authority_name} ({discount.percent_discount}%)
                            </div>
                        }
                        <div className='receipt-summary-data'>P{formatNumber(discount.discount_amount)}</div>
                      </div>
                      <div className='receipt-summary-item sub-content'>
                        <div className='discount-info-label'>ID Number:</div>
                        <div className='discount-info-data'>{discount.id_number}</div>
                      </div>
                      <div className='receipt-summary-item sub-content'>
                        <div className='discount-info-label'>Name:</div>
                        <div className='discount-info-data'>{discount.account_holder_name}</div>
                      </div>
                      <div className='receipt-summary-item sub-content'>
                        <div className='discount-info-label'>Signature:</div>
                        <div className='discount-info-data signature-underline'></div>
                      </div>
                    </div>
                  )))
                }
                <hr />

                <div className='receipt-summary-item'>
                  <div className='receipt-summary-label'>Total Amount Due</div>
                  <div className='receipt-summary-data'>P{formatNumber(totalAmountDue)}</div>
                </div>
                <hr />

                <div className='receipt-summary-item'>
                  <div className='receipt-summary-label'>Total Amount Received</div>
                  <div className='receipt-summary-data'>P{formatNumber(totalAmountPaid)}</div>
                </div>
                {
                  receipt.payments.map((payment, index) => (
                    (payment.name.search('total_') !== -1) ? null :
                      <div key={index} className='receipt-summary-item sub-content'>
                        <div className='receipt-summary-label'>{`${payment.name} Payment`}</div>
                        <div className='receipt-summary-data'>P{formatNumber(payment.total)}</div>
                      </div>
                  ))
                }
                <hr />

                <div className='receipt-summary-item'>
                  <div
                    style={{display: (totalBalanceChange === 0) ? 'none' : 'block'}}
                    className='receipt-summary-label'>{(totalBalanceChange > 0) ? <span>Balance</span> : <span>Change</span>}
                  </div>
                  <div
                    style={{display: (totalBalanceChange === 0) ? 'none' : 'block'}}
                    className='receipt-summary-data'>P{formatNumber(Math.abs(totalBalanceChange))}
                  </div>
                </div>

              </div>
            </div>

            <div className='receipt-footer'>
              <div className='paid-by-container'>
                <div className='paid-by-label'>Paid by:</div>
                <div className='paid-by-data'>
                  <div className='paid-by-name'>{(receipt.paid_by) ? receipt.paid_by : <span>Walked-in Costumer</span>}</div>
                  <div className='paid-by-signature'>Signature over printed name</div>
                </div>
              </div>

              <div className='prepared-by-container'>
                <div className='prepared-by-label'>Prepared by:</div>
                <div className='prepared-by-data'>
                  <div className='prepared-by-name'>{receipt.prepared_by}</div>
                  <div className='prepared-by-signature'>Signature over printed name</div>
                </div>
              </div>
            </div>
          </div>
          <OR8p5inchStyle />
          { (paperSize === '8.5inch') ? <PrinterSettingsStyle paperWidth='8.5inch'/> : null }
        </div>

        <div className='log-container'>
          <div className='created-by'>
            Created by {receipt.log.created_by.name} on {new Date(receipt.date_time_created).toLocaleString("en-us", { timeZone: receipt.client_timezone })} {receipt.client_timezone}
          </div>
          {
            (receipt.log.last_modified_by)
            ? <div className='last-modified-by'>
                Last modified by {receipt.log.last_modified_by.name} on {new Date(receipt.date_time_modified).toLocaleString("en-us", { timeZone: receipt.client_timezone })} {receipt.client_timezone}
              </div>
            : null
          }
        </div>
      </React.Fragment>
    )
  }

  function OR58mm() {
    return (
      <React.Fragment>
        <div id='OR58mm' className={(paperSize === '58mm') ? 'OR58mm printable' : 'OR58mm'}>
          <div className='receipt-header'>
            <div><b>{client.company_profile.company_name}</b></div>
            <div>
              {`
                ${client.company_address.street},
                ${client.company_address.zip_code} ${client.company_address.city},
                ${client.company_address.state} ${client.company_address.country}
              `}
            </div>
            <div>T.I.N: {client.company_profile.tin}</div>
            <div>Contact Number: {client.company_profile.contact_number}</div>
          </div>

          <div className='receipt-inner'>
            <div className='receipt-inner-message'>
              {
                (receipt.receipt_for.item_name === 'Invoice')
                ? `Payment for the ${paymentFor} ${receipt.receipt_for.item_id.toString().toUpperCase()} amounting to P${formatNumber(totalAmountToPay)}.`
                : `Payment for customer ${receipt.receipt_for.item_id.customer_account_id.toUpperCase()} with ${paymentFor} number ${receipt.receipt_for.item_id.credit_account_number.toString().toUpperCase()} amounting to P${formatNumber(totalAmountToPay)}.`
              }
            </div>
            <div className='receipt-summary'>
              <div className='receipt-summary-item'>
                <div className='receipt-summary-label'>Amount to Pay</div>
                <div className='receipt-summary-data'>{`P${formatNumber(totalAmountToPay)}`}</div>
              </div>
              <hr />

              <div className='receipt-summary-item'>
                <div className='receipt-summary-label'>Discount ({receipt.discounts.discount_total.total_percent_discount}%)</div>
                <div className='receipt-summary-data'>P{formatNumber(receipt.discounts.discount_total.total_discount_amount)}</div>
              </div>
              {
                (receipt.discounts.items.map((discount, index) => (
                  <div key={index}>
                    <div className='receipt-summary-item sub-content'>
                      {
                        (discount.vat_exempted)
                        ? <div className='receipt-summary-label'>
                          {discount.discount_authority_name} (VAT Exempted) ({discount.percent_discount}%)
                          </div>
                        : <div className='receipt-summary-label'>
                          {discount.discount_authority_name} ({discount.percent_discount}%)
                          </div>
                      }
                      <div className='receipt-summary-data'>P{formatNumber(discount.discount_amount)}</div>
                    </div>
                    <div className='receipt-summary-item sub-content'>
                      <div className='discount-info-label'>ID Number:</div>
                      <div className='discount-info-data'>{discount.id_number}</div>
                    </div>
                    <div className='receipt-summary-item sub-content'>
                      <div className='discount-info-label'>Name:</div>
                      <div className='discount-info-data'>{discount.account_holder_name}</div>
                    </div>
                    <div className='receipt-summary-item sub-content'>
                      <div className='discount-info-label'>Signature:</div>
                      <div className='discount-info-data signature-underline'></div>
                    </div>
                  </div>
                )))
              }
              <hr />

              <div className='receipt-summary-item'>
                <div className='receipt-summary-label'>Total Amount Due</div>
                <div className='receipt-summary-data'>P{formatNumber(totalAmountDue)}</div>
              </div>
              <hr />

              <div className='receipt-summary-item'>
                <div className='receipt-summary-label'>Total Amount Received</div>
                <div className='receipt-summary-data'>P{formatNumber(totalAmountPaid)}</div>
              </div>
              {
                receipt.payments.map((payment, index) => (
                  (payment.name.search('total_') !== -1) ? null :
                    <div key={index} className='receipt-summary-item sub-content'>
                      <div className='receipt-summary-label'>{`${payment.name} Payment`}</div>
                      <div className='receipt-summary-data'>P{formatNumber(payment.total)}</div>
                    </div>
                ))
              }
              <hr />

              <div className='receipt-summary-item'>
                <div
                  style={{display: (totalBalanceChange === 0) ? 'none' : 'block'}}
                  className='receipt-summary-label'>{(totalBalanceChange > 0) ? <span>Balance</span> : <span>Change</span>}
                </div>
                <div
                  style={{display: (totalBalanceChange === 0) ? 'none' : 'block'}}
                  className='receipt-summary-data'>P{formatNumber(Math.abs(totalBalanceChange))}
                </div>
              </div>

            </div>
          </div>
          <br/>

          <div className='receipt-footer'>
            <div className='paid-by-label'>Paid by:</div>
            <div className='paid-by-data'>{(receipt.paid_by) ? receipt.paid_by : <span>Walked-in Costumer</span>}</div>
          </div>
          <br/> <br/>
          <div className='receipt-footer'>
            <div className='prepared-by-label'>Prepared by:</div>
            <div className='prepared-by-data'>{receipt.prepared_by}</div>
          </div>
        </div>
        <OR58mmStyle />
      { (paperSize === '58mm') ? <PrinterSettingsStyle paperWidth='58mm'/> : null }
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <OR8p5inch />
      <OR58mm />
    </React.Fragment>
  )
}

function ExpressModeSalesInvoice() {
  const receiptItemController = useContext(receiptItemControllerContext)
  const { receipt, receiptFor, client } = receiptItemController
  const paperSize = receiptItemController.paperSize[0]
  const invoiceItem = receiptFor
  const totalAmountPaid = parseFloat(receipt.payments.find(item => item.name === 'total_amount_paid').total_amount_paid)
  const totalAmountDue = (parseFloat(receipt.amount_to_pay.total_amount) - parseFloat(receipt.discounts.discount_total.total_discount_amount))
  const totalBalanceChange = parseFloat(totalAmountDue - totalAmountPaid)

  function EMSI8p5inch() {
    return (
      <React.Fragment>
        <div className='report-wrapper'>
          <div id='invoice-item-container' className={(paperSize === '8.5inch') ? 'printable' : ''}>
            <div className='invoice-company-name-address-container'>
              <div><b>{client.company_profile.company_name}</b></div>
              <div>
                {`
                  ${client.company_address.street},
                  ${client.company_address.zip_code} ${client.company_address.city},
                  ${client.company_address.state} ${client.company_address.country}
                `}
              </div>
              <div>T.I.N: {client.company_profile.tin}</div>
              <div>Contact Number: {client.company_profile.contact_number}</div>
            </div>
            <br/>
            <div id='invoice-item-header'>
              <div id='invoice-item-header-left'>
                <div style={{fontSize: '1.1rem', marginBottom: '5px'}}><b>Invoice/Receipt</b></div>
                <div><b>Invoice Number:</b> {invoiceItem._id.toUpperCase()}</div>
              </div>
              <div id='invoice-item-header-right'>
                <div style={{textAlign: 'right'}}>{new Date(receipt.receipt_date).toLocaleString("en-us", { timeZone: receipt.client_timezone })} { receipt.client_timezone }</div>
              </div>
            </div>

            {/* COSTUMERS'S DETAILS */}
            <table id='table-customer-details' className='table-invoice-item'>
              <tbody>
                <tr>
                  <th style={{textAlign: 'left', width: '15%'}}>Sold To:</th>
                  <td style={{width: '35%'}}>{invoiceItem.customer_details.sold_to}</td>
                  <th style={{textAlign: 'left', width: '10%'}}>Address:</th>
                  <td style={{width: '40%'}}>{invoiceItem.customer_details.address}</td>
                </tr>
                <tr>
                  <th style={{textAlign: 'left', width: '15%'}}>Contact Number:</th>
                  <td style={{width: '35%'}}>{invoiceItem.customer_details.contact_number}</td>
                  <th style={{textAlign: 'left', width: '10%'}}>Remarks:</th>
                  <td style={{width: '40%'}}>{invoiceItem.customer_details.remarks}</td>
                </tr>
              </tbody>
            </table>

            {/* IVOICE PARTICULARS */}
            <table id='table-item-paticulars' className='table-invoice-item'>
              <thead>
                <tr>
                  <th style={{textAlign: 'left', width: '55%'}}>Item Name</th>
                  <th style={{textAlign: 'left', width: '20%'}}>Unit</th>
                  <th style={{textAlign: 'right'}}>Unit Price</th>
                  <th style={{textAlign: 'center'}}>Quantity</th>
                  <th style={{textAlign: 'right'}}>Amount</th>
                </tr>
              </thead>
              {
                invoiceItem.invoice_particulars.map((item, index) => (
                  <tbody key={index}>
                    <tr>
                      <td style={{textAlign: 'left'}}>{`${item.item_name} ${item.item_remarks}`}</td>
                      <td style={{textAlign: 'left'}}>{item.unit}</td>
                      <td style={{textAlign: 'right'}}>P{formatNumber(item.unit_price)}</td>
                      <td style={{textAlign: 'center'}}>{formatNumber(item.quantity)}</td>
                      <td style={{textAlign: 'right'}}>P{formatNumber(item.amount)}</td>
                    </tr>
                  </tbody>
                ))
              }
            </table>

            {/************* Invoice Summary ******************/}
            {/********************** VATed Sales *********************/}
            <div className='invoice-summary-container'>
              <div className='invoice-summary-item'>
                <div className='item-label'>Vatable Sales</div>
                <div id='invoice-vatable-sales' className='item-data'>
                  P{formatNumber(invoiceItem.invoice_summary.vat_total_sales - invoiceItem.invoice_summary.vat_amount)}
                </div>
              </div>
              <div className='invoice-summary-item'>
                <div className='item-label'>VAT ({invoiceItem.vat}%)</div>
                <div id='invoice-vat-amount' className='item-data'>
                  P{formatNumber(invoiceItem.invoice_summary.vat_amount)}
                </div>
              </div>
              <div className='invoice-summary-item'>
                <div className='item-label'>VATed Total Item(s)</div>
                <div id='invoice-vatable-sales' className='item-data'>
                  {formatNumber(invoiceItem.invoice_summary.vat_total_items)}
                </div>
              </div>
              <div className='invoice-summary-item'>
                <div className='item-label'>VATed Total Amount</div>
                <div id='invoice-vatable-sales' className='item-data'>
                  P{formatNumber(invoiceItem.invoice_summary.vat_total_sales)}
                </div>
              </div>
              <hr />

              {/**************** NONE VAT *******************/}
              <div className='invoice-summary-item'>
                <div className='item-label'>None-VAT Total Item(s)</div>
                <div id='invoice-vatable-sales' className='item-data'>
                  {formatNumber(invoiceItem.invoice_summary.none_vat_total_items)}
                </div>
              </div>
              <div className='invoice-summary-item'>
                <div className='item-label'>None-VAT Sales</div>
                <div id='invoice-vatable-sales' className='item-data'>
                  P{formatNumber(invoiceItem.invoice_summary.none_vat_total_sales)}
                </div>
              </div>
              <hr />

              {/************* Total Sales ***************/}
              <div className='invoice-summary-item'>
                <div className='item-label'>Grand Total Item(s)</div>
                <div id='invoice-total-items' className='item-data'>
                  {formatNumber(invoiceItem.invoice_summary.total_item)}
                </div>
              </div>
              <div className='invoice-summary-item'>
                <div className='item-label'>Grand Total Sales</div>
                <div id='invoice-total-items' className='item-data'>
                  P{formatNumber(invoiceItem.invoice_summary.total_sales)}
                </div>
              </div>
              <hr />

              {/****************** (Receipt) Discount ****************/}
              <div className='invoice-summary-item'>
                <div className='item-label'>
                  {`Discount (${formatNumber(receipt.discounts.discount_total.total_percent_discount)}%)`}
                </div>
                <div id='invoice-discount' className='item-data'>
                  P{formatNumber(receipt.discounts.discount_total.total_discount_amount)}
                </div>
              </div>
              {
                receipt.discounts.items.map((discount, index)=> (
                  (discount.vat_exempted)
                  ?
                    <div key={index}>
                      <div className='invoice-summary-item sub-content'>
                        <div className='item-label'>
                          {discount.discount_authority_name} (VAT Exempted)
                          &nbsp;({parseFloat(discount.percent_discount).toFixed(2)}%)
                        </div>
                        <div className='item-data'>
                          P{formatNumber(parseFloat(discount.discount_amount).toFixed(2))}
                        </div>
                      </div>
                      <div className='invoice-summary-item sub-content'>
                        <div className='discount-info-label'>ID Number:</div>
                        <div className='discount-info-data'>{discount.id_number}</div>
                      </div>
                      <div className='invoice-summary-item sub-content'>
                        <div className='discount-info-label'>Name:</div>
                        <div className='discount-info-data'>{discount.account_holder_name}</div>
                      </div>
                      <div className='invoice-summary-item sub-content'>
                        <div className='discount-info-label'>Signature:</div>
                        <div className='discount-info-data signature-underline'></div>
                      </div>
                    </div>
                  : <div key={index}className='invoice-summary-item discount'>
                      <div className='item-label'>
                        {discount.discount_authority_name}
                        &nbsp;({formatNumber(parseFloat(discount.percent_discount).toFixed(2))}%)
                      </div>
                      <div className='item-data'>
                        P{formatNumber(parseFloat(discount.discount_amount).toFixed(2))}
                      </div>
                    </div>
                ))
              }
              <hr />

              {/************* Total Amount Due*******************/}
              <div className='invoice-summary-item'>
                <div className='item-label'><b>Total Amount Due</b></div>
                <div id='invoice-total-amount-due' className='item-data'>
                  <b>P{formatNumber(totalAmountDue)}</b>
                </div>
              </div>
              <hr/>
            </div>

            {/************* Receipt Details ******************/}
            <div className='invoice-summary-container'>
              <div className='invoice-summary-item'>
                <div className='item-label'>Total Amount Received</div>
                <div className='item-data'>P{formatNumber(totalAmountPaid)}</div>
              </div>
              {
                receipt.payments.map((payment, index) => (
                  (payment.name.search('total_') !== -1)
                  ? null
                  : <div key={index} className='invoice-summary-item sub-content'>
                      <div className='item-label'>{`${payment.name} Payment`}</div>
                      <div className='item-data'>P{formatNumber(payment.total)}</div>
                    </div>
                ))
              }
              <hr />

              <div className='invoice-summary-item' style={{display: (totalBalanceChange === 0) ? 'none' : 'flex'}}>
                <div className='item-label'>{(totalBalanceChange > 0) ? <span>Balance</span> : <span>Change</span>}</div>
                <div className='item-data'>P{formatNumber(Math.abs(totalBalanceChange))}</div>
              </div>
            </div>

            <br/>

            <div className='prepared-by-container'>
              <div className='prepared-by-label'>Prepared by:</div>
              <div>{receipt.prepared_by}</div>
            </div>

            <div style={{alignSelf: 'flex-end', marginTop: '10px'}}>O.R. #: {receipt._id.toUpperCase()}</div>
          </div>
          <EMSI8p5inchStyle />
          { (paperSize === '8.5inch') ? <PrinterSettingsStyle paperWidth='8.5inch'/> : null }
        </div>

        <div className='log-container'>
          <div className='created-by'>
            Created by {receipt.log.created_by.name} on {new Date(receipt.date_time_created).toLocaleString("en-us", { timeZone: receipt.client_timezone })} { receipt.client_timezone }
          </div>
          {
            (receipt.log.last_modified_by)
            ? <div className='last-modified-by'>
                Last modified by {receipt.log.last_modified_by.name} on {new Date(receipt.date_time_modified).toLocaleString("en-us", { timeZone: receipt.client_timezone})} { receipt.client_timezone }
              </div>
            : null
          }
        </div>
      </React.Fragment>
    )
  }

  function EMSI58mm() {
    return (
      <React.Fragment>
        <div id='invoice-58mm' className={(paperSize === '58mm') ? 'invoice-58mm printable' : 'invoice-58mm'}>
          <div id='invoice-58mm-header'>
            <div><b>{client.company_profile.company_name}</b></div>
            <div>
              {`
                ${client.company_address.street},
                ${client.company_address.zip_code} ${client.company_address.city},
                ${client.company_address.state} ${client.company_address.country}
              `}
            </div>
            <div>T.I.N: {client.company_profile.tin}</div>
            <div>Contact Number: {client.company_profile.contact_number}</div>
            <div id='invoice-details-container'>
              <div style={{textAlign: 'center'}}><b>Invoice/Receipt</b></div>
              <div><b>Invoice Number</b></div><div>{invoiceItem._id.toUpperCase()}</div>
              {/* <div><b>Invoice Date</b></div><div>{simpleDateString(new Date(receipt.receipt_date))}</div> */}
              <div><b>Invoice Date</b></div><div>{new Date(receipt.receipt_date).toLocaleString("en-us", { timeZone: receipt.client_timezone })} { receipt.client_timezone } </div>
              <div className={(invoiceItem.customer_details.sold_to) ? 'invoice-details-show' : 'invoice-details-hide'}>
                <div><b>Sold To</b></div><div>{invoiceItem.customer_details.sold_to}</div>
              </div>
              <div className={(invoiceItem.customer_details.address) ? 'invoice-details-show' : 'invoice-details-hide'}>
                <div><b>Customers Address</b></div><div>{invoiceItem.customer_details.address}</div>
              </div>
              <div className={(invoiceItem.customer_details.contact_number) ? 'invoice-details-show' : 'invoice-details-hide'}>
                <div><b>Customers Contact Number</b></div><div>{invoiceItem.customer_details.contact_number}</div>
              </div>
              <div className={(invoiceItem.customer_details.remarks) ? 'invoice-details-show' : 'invoice-details-hide'}>
                <div><b>Remarks</b></div><div>{invoiceItem.customer_details.remarks}</div>
              </div>
            </div>
          </div>

          <div style={{textAlign: 'center'}}><b>*** ITEMS LIST ***</b></div>
          <div className='items-list'>
            {
              invoiceItem.invoice_particulars.map((ip, index) => (
                <div key={index} className='item-wrapper'>
                  <div>{index+1}) {ip.item_name}</div>
                  <div>{`${ip.quantity} ${ip.unit} @P${formatNumber(ip.unit_price)} -> P${formatNumber(ip.amount)} ${(ip.vatable) ? 'V' : ''}`}</div>
                  <div style={{display: ((index + 1) === invoiceItem.invoice_particulars.length) ? 'none' : 'block'}}>---</div>
                </div>
              ))
            }
          </div>

          {/* INVOICE SUMMARY */}
          {/********************** VATed Sales *********************/}
          <div className='invoice-summary-container'>
            <div className='invoice-summary-item'>
              <div className='item-label'>Vatable Sales</div>
              <div id='invoice-vatable-sales' className='item-data'>
                P{formatNumber(invoiceItem.invoice_summary.vat_total_sales - invoiceItem.invoice_summary.vat_amount)}
              </div>
            </div>
            <div className='invoice-summary-item'>
              <div className='item-label'>VAT ({invoiceItem.vat}%)</div>
              <div id='invoice-vat-amount' className='item-data'>
                P{formatNumber(invoiceItem.invoice_summary.vat_amount)}
              </div>
            </div>
            <div className='invoice-summary-item'>
              <div className='item-label'>VATed Total Item(s)</div>
              <div id='invoice-vatable-sales' className='item-data'>
                {formatNumber(invoiceItem.invoice_summary.vat_total_items)}
              </div>
            </div>
            <div className='invoice-summary-item'>
              <div className='item-label'>VATed Total Amount</div>
              <div id='invoice-vatable-sales' className='item-data'>
                P{formatNumber(invoiceItem.invoice_summary.vat_total_sales)}
              </div>
            </div>
            <hr />

            {/**************** NONE VAT *******************/}
            <div className='invoice-summary-item'>
              <div className='item-label'>None-VAT Total Item(s)</div>
              <div id='invoice-vatable-sales' className='item-data'>
                {formatNumber(invoiceItem.invoice_summary.none_vat_total_items)}
              </div>
            </div>
            <div className='invoice-summary-item'>
              <div className='item-label'>None-VAT Sales</div>
              <div id='invoice-vatable-sales' className='item-data'>
                P{formatNumber(invoiceItem.invoice_summary.none_vat_total_sales)}
              </div>
            </div>
            <hr />

            {/******************** Total Sales **********************/}
            <div className='invoice-summary-item'>
              <div className='item-label'>Grand Total Item(s)</div>
              <div id='invoice-total-items' className='item-data'>
                {formatNumber(invoiceItem.invoice_summary.total_item)}
              </div>
            </div>
            <div className='invoice-summary-item'>
              <div className='item-label'>Grand Total Sales</div>
              <div id='invoice-total-items' className='item-data'>
                P{formatNumber(invoiceItem.invoice_summary.total_sales)}
              </div>
            </div>
            <hr />

            {/****************** (Receipt) Discount ****************/}
            <div className='invoice-summary-item'>
              <div className='item-label'>
                {`Discount (${formatNumber(receipt.discounts.discount_total.total_percent_discount)}%)`}
              </div>
              <div id='invoice-discount' className='item-data'>
                P{formatNumber(receipt.discounts.discount_total.total_discount_amount)}
              </div>
            </div>
            {
              receipt.discounts.items.map((discount, index) => (
                (discount.vat_exempted)
                ?
                  <div key={index}>
                    <div className='invoice-summary-item sub-content'>
                      <div className='item-label'>
                        {discount.discount_authority_name} (VAT Exempted)
                        &nbsp;({parseFloat(discount.percent_discount).toFixed(2)}%)
                      </div>
                      <div className='item-data'>
                        P{formatNumber(parseFloat(discount.discount_amount).toFixed(2))}
                      </div>
                    </div>
                    <div className='invoice-summary-item sub-content'>
                      <div className='discount-info-label'>ID Number:</div>
                      <div className='discount-info-data'>{discount.id_number}</div>
                    </div>
                    <div className='invoice-summary-item sub-content'>
                      <div className='discount-info-label'>Name:</div>
                      <div className='discount-info-data'>{discount.account_holder_name}</div>
                    </div>
                    <div className='invoice-summary-item sub-content'>
                      <div className='discount-info-label'>Signature:</div>
                      <div className='discount-info-data signature-underline'></div>
                    </div>
                  </div>
                : <div key={index} className='invoice-summary-item sub-content'>
                    <div className='item-label'>
                      {discount.discount_authority_name}
                      &nbsp;({formatNumber(parseFloat(discount.percent_discount).toFixed(2))}%)
                    </div>
                    <div className='item-data'>
                      P{formatNumber(parseFloat(discount.discount_amount).toFixed(2))}
                    </div>
                  </div>
              ))
            }
            <hr />

            {/************* Total Amount Due*******************/}
            <div className='invoice-summary-item'>
              <div className='item-label'><b>Total Amount Due</b></div>
              <div id='invoice-total-amount-due' className='item-data'>
                <b>P{formatNumber(totalAmountDue)}</b>
              </div>
            </div>
          </div>
          <hr />

          {/************* Receipt Details ******************/}
          <div className='invoice-summary-container'>
            <div className='invoice-summary-item'>
              <div className='item-label'>Total Amount Received</div>
              <div className='item-data'>P{formatNumber(totalAmountPaid)}</div>
            </div>
            {
              receipt.payments.map((payment, index) => (
                (payment.name.search('total_') !== -1)
                ? null
                : <div key={index} className='invoice-summary-item sub-content'>
                    <div className='item-label'>{`${payment.name} Payment`}</div>
                    <div className='item-data'>P{formatNumber(payment.total)}</div>
                  </div>
              ))
            }
            <hr />

            <div className='invoice-summary-item' style={{display: (totalBalanceChange === 0) ? 'none' : 'flex'}}>
              <div className='item-label'>{(totalBalanceChange > 0) ? <span>Balance</span> : <span>Change</span>}</div>
              <div className='item-data'>P{formatNumber(Math.abs(totalBalanceChange))}</div>
            </div>
          </div>

          <br/>
          <div className='prepared-by-container'>
            <div className='prepared-by-label'>Prepared by:</div>
            <div>{receipt.prepared_by}</div>
          </div>

          {/**** OR Details ****/}
          <div style={{alignSelf: 'flex-start', marginTop: '5px'}}>O.R. #: {receipt._id.toUpperCase()}</div>
        </div>

        <EMSI58mmStyle />
        { (paperSize === '58mm') ? <PrinterSettingsStyle paperWidth='58mm'/> : null }
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <EMSI8p5inch />
      <EMSI58mm />
    </React.Fragment>
  )
}

function viewReceipt(receipt_type) {
  switch(receipt_type) {
    case 'OR': return <OfficialReceipt />
    case 'EMSI': return <ExpressModeSalesInvoice />
    default:
  }
}

function ReceiptItemInner() {
  const receiptItemController = useContext(receiptItemControllerContext)
  const receiptToView = receiptItemController.receiptToView[0]
  return (
    <ContentInner>
      { viewReceipt(receiptToView) }
    </ContentInner>
  )
}

export default React.memo(ReceiptItemInner)